import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=c56713f4&scoped=true&"
import script from "./NoticeList.vue?vue&type=script&lang=js&"
export * from "./NoticeList.vue?vue&type=script&lang=js&"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=c56713f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56713f4",
  null
  
)

export default component.exports